export default "__VITE_ASSET__DHNVPFYN__$_?component__"